"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpError = void 0;
var openapi_1 = require("@samchon/openapi");
Object.defineProperty(exports, "HttpError", { enumerable: true, get: function () { return openapi_1.HttpError; } });
//# sourceMappingURL=HttpError.js.map